import React from 'react';
import { BsGrid3X3GapFill } from 'react-icons/bs';
import styles from '@/styles/components/MenuGrid.module.css';
import { ActionButton } from '@ax2/common/components/ActionButton';
import { history } from 'helpers/router';

const MenuGrid = ({
  onClick,
  submenuVisible,
}: {
  onClick: any;
  submenuVisible: any;
}) => {
  return (
    <div className={styles.popupContainer} onBlur={onClick} tabIndex={0}>
      <div className={styles.menuItem} onClick={onClick}>
        <span
          className={`${styles.icon} ${
            submenuVisible ? styles.iconActive : ''
          }`}
        >
          <BsGrid3X3GapFill size={30} />
        </span>
      </div>

      {submenuVisible && (
        <div className={styles.popup}>
          <div className={styles.popupGrid}>
            <ActionButton
              key="statistics"
              text={'Survey Stats'}
              type="secondaryAlt"
              onClick={() => history.push('/metrics?page=1')}
              shadowHover="2"
              shadowNormal="none"
            />
            <ActionButton
              key="user-management"
              text={'User Management'}
              type="secondaryAlt"
              onClick={() => history.push('/user-management?page=1')}
              shadowHover="2"
              shadowNormal="none"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MenuGrid;
